import styled from 'styled-components'

/**
 * gold8.bet /GenericCasino 실측(1440 화면):
 *   본문 폭 1200 · 머리 80px(왼쪽 로고 284×80, 오른쪽 노란 검색 상자 200×40) ·
 *   탭 알약 높이 30 / 글자 15 흰색, 선택 탭 = 흰 바탕 + 노란 글자(#ffd343) ·
 *   배너 1200 폭 아래 16 · 섹션 머리표 노란(#ffd343) 위쪽만 둥근 8px + 같은 색 밑줄 ·
 *   게임 카드 163×184, 흰 바탕, 테두리 1px #ccc, 모서리 10, 안쪽 8, 그림 145×145, 한 줄 7개.
 */
const YELLOW = '#ffd343'

export const Page = styled.div`
  min-height: 100vh;
  padding-bottom: 60px;
  background: #000;
`

export const Wrapper = styled.div`
  width: 1200px;
  max-width: calc(100% - 40px);
  margin: 0 auto;
  ${({ $row }) => ($row ? 'display: flex; align-items: center; justify-content: space-between; height: 80px;' : '')}
  ${({ $content }) => ($content ? 'padding-top: 15px;' : '')}
`

export const Header = styled.div`
  height: 80px;
`

export const Logo = styled.div`
  display: flex;
  align-items: center;
  width: 284px;
  height: 80px;
  img { max-width: 100%; max-height: 100%; object-fit: contain; }
`

export const LogoText = styled.span`
  font-size: 28px;
  font-weight: 700;
  color: #fff;
`

export const Search = styled.form`
  display: flex;
  align-items: center;
  width: 200px;
  height: 40px;
  padding: 5px;
  border-radius: 3px;
  background: ${YELLOW};

  input {
    width: 150px;
    height: 30px;
    margin-right: 5px;
    padding: 0 5px;
    border: 0;
    background: #fff;
    font-size: 12px;
    color: #000;
    outline: none;
  }
  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    padding: 0;
    border: 0;
    background: none;
    color: #fff;
    cursor: pointer;
  }
  svg { width: 20px; height: 20px; fill: currentColor; color: inherit; }
`

export const Nav = styled.div`
  height: 50px;
`

export const Tabs = styled.ul`
  display: flex;
  margin: 0;
  padding: 10px 0 0;
  list-style: none;
  li { margin: 0 10px 10px 0; }
`

export const TabBtn = styled.button`
  height: 30px;
  padding: 0 15px;
  border: 0;
  border-radius: 15px;
  background: ${({ $active }) => ($active ? '#fff' : 'transparent')};
  font-size: 15px;
  line-height: 30px;
  color: ${({ $active }) => ($active ? YELLOW : '#fff')};
  cursor: pointer;
`

export const Banner = styled.img`
  display: block;
  width: 100%;
  height: auto;
  margin-bottom: 16px;
`

export const Section = styled.section`
  margin-bottom: 30px;
`

export const SectionTitle = styled.p`
  display: flex;
  margin: 0 0 16px;
  border-bottom: 2px solid ${YELLOW};
  span {
    height: 30px;
    padding: 0 15px;
    border-radius: 8px 8px 0 0;
    background: ${YELLOW};
    font-size: 15px;
    line-height: 30px;
    color: #fff;
  }
`

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 163px);
  justify-content: space-between;
  row-gap: 16px;
`

export const Slider = styled.div`
  display: flex;
  gap: 10px;
  padding: 5px 0;
  overflow-x: auto;
  scrollbar-width: thin;
  & > * { flex: 0 0 163px; }
`

export const Card = styled.div`
  width: 163px;
  padding: 8px 8px 5px;
  border: 1px solid #ccc;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  &:hover > div:first-child > div:last-child { opacity: 1; }
`

export const CardSkeleton = styled.div`
  width: 163px;
  height: 184px;
  border-radius: 10px;
  background: #1a1a1a;
`

export const ImgBox = styled.div`
  position: relative;
  width: 145px;
  height: 145px;
  overflow: hidden;
  img { width: 100%; height: 100%; object-fit: cover; }
`

export const Mask = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.45);
  opacity: 0;
  transition: opacity 0.2s;
`

export const Play = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  padding-left: 4px;
  border: 2px solid #fff;
  border-radius: 50%;
  font-size: 20px;
  color: #fff;
`

export const Name = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  margin-top: 6px;
  font-size: 12px;
  color: #000;
  span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #000;
  }
`

